"use client"
import { useGSAP } from "@gsap/react"
import clsx from "clsx"
import gsap from "gsap"
import { useEffect, useRef } from "react"
import Cta from "@/components/cta/cta"

import Map from "@/components/icon/map"
import Navigation from "@/components/icon/navigation"
import {STORIES_BASE_PATH} from "@/constants/routes";
import { useApp } from "@/context/AppContext"


export default function RecordsStickyNav({isSticky}) {
  const { isAppReady, isRecordsNavOverlayOpen, setIsRecordsNavOverlayOpen } = useApp()
  const isRecordNavOpenRef = useRef(false);
  const root = useRef(null)
  const catsButtonRef = useRef(null)

  useGSAP(() => {
    if (isAppReady) {
      const mm = gsap.matchMedia();

      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.set(root.current, {
          opacity: 1,
          y: '0%'
        })
      });

      mm.add("(prefers-reduced-motion: no-preference)", () => {
        gsap.to(root.current, {
          opacity: 1,
          duration: 0.4,
          ease: 'linear.none',
          delay: 1
        })

        gsap.fromTo(root.current, {
          y: '100%'
        }, {
          y: '0%',
          duration: 1.2,
          ease: 'expo.out',
          delay: 1
        })
      });

      return () => mm.revert();
    }
  }, [isAppReady])

  useEffect(() => {
    if (!isRecordsNavOverlayOpen && isRecordNavOpenRef.current) {
      catsButtonRef.current?.focus();
    }

    isRecordNavOpenRef.current = isRecordsNavOverlayOpen
  }, [isRecordsNavOverlayOpen])
  return (
    <nav ref={root} className={clsx(
      "w-full bottom-(--space-7) -mt-[calc(2*var(--space-7))] gap-x-(--space-3) left-0 flex justify-center z-20 opacity-0 will-change-transform",
      isSticky ? "sticky" : 'sticky '
    )}>
      <Cta className={clsx("cta-icon cta-icon-stroke-theme", isSticky ? "cta-theme-reverse" : "cta-bottom-theme-reverse")} href={`${STORIES_BASE_PATH}/map`} transitionName="overlay-in"><Map /><span>Map</span></Cta>
      <Cta className={clsx("cta-icon cta-icon-stroke-theme", isSticky ? "cta-theme-reverse" : "cta-bottom-theme-reverse")} onClick={() => setIsRecordsNavOverlayOpen(true)} ref={catsButtonRef}><Navigation /><span>Categories</span></Cta>
    </nav>
  )
}
